import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const OpenInNewTabLink = () => {
  return (
    <a href={window.location.href} rel="noreferrer nofollow" target="_blank">
      <FontAwesomeIcon className="mr-2" icon={faExternalLink} />
      Open In New Tab
    </a>
  );
};

export default OpenInNewTabLink;
